<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="dialog-title">{{data.prevTask
    ? ('modules.crm.leads.taskDialog.nextTitle' | translate)
    : ('modules.crm.leads.taskDialog.title' | translate)}}</div>
  <div class="dialog-close" (click)="minimize()" *ngIf="data.edit">
    <mat-icon>minimize</mat-icon>
  </div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="dialog-content no-overflow" [ngClass]="{'no-bottom-padding' : data.edit}">
  <div class="no-overflow full-height df gap20 df">
    <div class="no-overflow df-c grow">
      <div class="dialog-header" *ngIf="data.edit">
        <div class="item-statuses">
          <div class="item-status task SCHEDULED clip-first" [class]="{'current': data.task?.status === 'SCHEDULED'}" (click)="changeStatus('SCHEDULED')">
            <span>{{'modules.crm.leads.taskStatuses.SCHEDULED' | translate}}</span>
          </div>
          <div class="item-status task IN_WORK clip-center" [class]="{'current': data.task?.status === 'IN_WORK'}" (click)="changeStatus('IN_WORK')">
            <span>{{'modules.crm.leads.taskStatuses.IN_WORK' | translate}}</span>
          </div>
          <div class="item-status task DONE single clip-last-single" [class]="{'current': data.task?.status === 'DONE'}"
               (click)="changeStatus('DONE')" *ngIf="data.task?.type !== 'LEAD'">
            <span>{{'modules.crm.leads.taskStatuses.DONE' | translate}}</span>
          </div>
          <div class="clip-last df-c gap5" *ngIf="data.task?.type === 'LEAD'">
            <div class="item-status task DONE" [class]="{'current': data.task?.status === 'DONE'}" (click)="changeStatus('DONE')">
              <span>{{'modules.crm.leads.taskStatuses.DONE' | translate}}</span>
            </div>
            <div class="item-status task FAIL" [class]="{'current': data.task?.status === 'FAIL'}" (click)="changeStatus('FAIL')">
              <span>{{'modules.crm.leads.taskStatuses.FAIL' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
      <form [formGroup]="taskForm" class="dialog-form scroll-content-padding scrollable df-c gap15" autocomplete="off">
        <div class="df gap20">
          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 220px; min-width: 220px">
            <mat-label>{{'modules.crm.leads.taskDialog.labels.priority' | translate}}</mat-label>
            <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="priority">
              <mat-option [value]="'LOW'">{{'modules.crm.leads.taskPriorities.LOW' | translate}}</mat-option>
              <mat-option [value]="'MIDDLE'">{{'modules.crm.leads.taskPriorities.MIDDLE' | translate}}</mat-option>
              <mat-option [value]="'HIGH'">{{'modules.crm.leads.taskPriorities.HIGH' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width grow">
            <mat-label>{{'modules.crm.leads.taskDialog.labels.type' | translate}}</mat-label>
            <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="type">
              <mat-option [value]="'CALL'" *ngIf="!data.prevTask">{{'modules.crm.leads.taskTypes.CALL' | translate}}</mat-option>
              <mat-option [value]="'LEAD'" *ngIf="!data.prevTask && currentUser?.crmBoardType === 'CRM'">{{'modules.crm.leads.taskTypes.LEAD' | translate}}</mat-option>
              <mat-option [value]="'TASK'">{{'modules.crm.leads.taskTypes.TASK' | translate}}</mat-option>
              <mat-option [value]="'SUPPORT'">{{'modules.crm.leads.taskTypes.SUPPORT' | translate}}</mat-option>
              <mat-option [value]="'DATA'">{{'modules.crm.leads.taskTypes.DATA' | translate}}</mat-option>
              <mat-option [value]="'DEMO'">{{'modules.crm.leads.taskTypes.DEMO' | translate}}</mat-option>
              <mat-option [value]="'REGISTRATION'">{{'modules.crm.leads.taskTypes.REGISTRATION' | translate}}</mat-option>
              <mat-option [value]="'IMPLEMENTATION'">{{'modules.crm.leads.taskTypes.IMPLEMENTATION' | translate}}</mat-option>
              <mat-option [value]="'OVERVIEW'">{{'modules.crm.leads.taskTypes.OVERVIEW' | translate}}</mat-option>
              <mat-option [value]="'CONTRACT'">{{'modules.crm.leads.taskTypes.CONTRACT' | translate}}</mat-option>
              <mat-option [value]="'UX'">{{'modules.crm.leads.taskTypes.UX' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="df gap20">
          <autocomplete-item-field style="width: 220px; min-width: 220px; max-width: 220px"
                                   [required]="true"
                                   [dataType]="'MANAGER'"
                                   [readonly]="!checkPermissions('TASK_ADD') && !checkPermissions('TASK_EDIT') && !checkPermissions('CRM_MANAGER_EDIT')"
                                   label="{{'modules.crm.leads.taskDialog.labels.responsible' | translate}}"
                                   formControlName="manager">
          </autocomplete-item-field>
        </div>

        <div class="df gap10" *ngIf="taskForm.get('manager')?.value.id">
          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 150px; min-width: 150px">
            <mat-label>{{'modules.crm.leads.taskDialog.labels.date' | translate}}</mat-label>
            <input matInput [matDatepicker]="date" formControlName="date" [min]="minDate"
                   [matDatepickerFilter]="weekdaysFilter"
            >
            <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
            <mat-datepicker #date></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 120px; min-width: 120px">
            <mat-label>{{'modules.crm.leads.taskDialog.labels.time' | translate}}</mat-label>
            <mat-select class="select-panel"
                        panelClass="dialog-select-panel" placeholder="{{'modules.crm.leads.emptyTime' | translate}}"
                        disableOptionCentering="true" formControlName="time"
                        (selectionChange)="timeSelected($event.value)"
            >
              <div *ngFor="let hour of (scheduler$ | async)">
                <div *ngFor="let minute of hour.tasks">
                  <mat-option *ngIf="(!minute.busy && !data.edit) || data.edit" [value]="minute.from?.substr(0, 5)">
                    {{minute.from?.substr(0, 5)}}
                  </mat-option>
                </div>
              </div>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 120px; min-width: 120px">
            <mat-label>{{'modules.crm.leads.taskDialog.labels.endTime' | translate}}</mat-label>
            <mat-select [disabled]="!taskForm.get('time')?.value" class="select-panel" panelClass="dialog-select-panel" placeholder="{{'modules.crm.leads.emptyTime' | translate}}" disableOptionCentering="true" formControlName="endTime">
              <div *ngFor="let hour of (endTime$ | async)">
                <div *ngFor="let minute of hour.tasks">
                  <mat-option *ngIf="(!minute.busy && !data.edit) || data.edit" [value]="minute.from?.substr(0, 5)">
                    {{minute.from?.substr(0, 5)}}
                  </mat-option>
                </div>
              </div>
            </mat-select>
          </mat-form-field>

          <button class="button-form-field gray df jc-e ai-c" [matMenuTriggerFor]="rescheduleMenu"
                  *ngIf="!readonlyFlag"
                  matTooltipClass="dialog-tooltip"
                  matTooltip="{{'modules.crm.leads.taskDialog.labels.reschedule' | translate}}">
            <mat-icon class="button-form-field-icon">update</mat-icon>
          </button>

          <mat-menu #rescheduleMenu xPosition="after" class="wide-menu">
            <button mat-menu-item class="item-action-button gray" (click)="reschedule('today')">
              <span>{{'modules.crm.leads.taskDialog.labels.rescheduleItems.today' | translate}}</span>
            </button>
            <button mat-menu-item class="item-action-button gray" (click)="reschedule('tomorrow')">
              <span>{{'modules.crm.leads.taskDialog.labels.rescheduleItems.tomorrow' | translate}}</span>
            </button>
          </mat-menu>

          <button class="button-form-field gray df jc-e ai-c" (click)="openManagerSchedule()"
                  *ngIf="!readonlyFlag"
                  matTooltipClass="dialog-tooltip"
                  matTooltip="{{'modules.crm.leads.taskDialog.labels.openCalendar' | translate}}">
            <mat-icon class="button-form-field-icon">today</mat-icon>
          </button>
        </div>

        <div class="df gap20">
          <autocomplete-item-field class="grow"
                                   *ngIf="!data.projectContacts"
                                   [dataType]="'CONTACT'"
                                   [multiline]="true"
                                   [canOpenList]="true"
                                   [canOpenItem]="!data.contact?.id"
                                   [readonly]="!!data.contact?.id || readonlyFlag"
                                   [canAddItem]="checkPermissions('CONTACT_ADD')"
                                   [canEditItem]="checkPermissions('CONTACT_EDIT')"
                                   [canDeleteItem]="checkPermissions('CONTACT_EDIT')"
                                   [required]="taskForm.get('type')?.value === 'CALL' || taskForm.get('type')?.value === 'LEAD'"
                                   label="{{'modules.crm.leads.taskDialog.labels.contact' | translate}}"
                                   formControlName="contact">
          </autocomplete-item-field>

          <autocomplete-item-field class="grow"
                                   *ngIf="data.projectContacts"
                                   [initialItems]="projectContacts"
                                   [dataType]="'CONTACT'"
                                   [multiline]="true"
                                   [canOpenList]="false"
                                   [canOpenItem]="!data.contact?.id"
                                   [readonly]="!!data.contact?.id || readonlyFlag"
                                   [required]="taskForm.get('type')?.value === 'CALL' || taskForm.get('type')?.value === 'LEAD'"
                                   label="{{'modules.crm.leads.taskDialog.labels.projectContacts' | translate}}"
                                   formControlName="contact">
          </autocomplete-item-field>

          <div class="df gap10">
            <button class="button-form-field green df jc-c ai-c" [disabled]="!taskForm.get('contact')?.value.description" [matMenuTriggerFor]="phoneMenu">
              <mat-icon class="button-form-field-icon">call</mat-icon>
            </button>
          </div>

          <mat-menu #phoneMenu xPosition="before" class="wide-menu">
            <div *ngIf="taskForm.get('contact')?.value.description">
              <button mat-menu-item class="item-action-button gray"
                      *ngFor="let phone of taskForm.get('contact')?.value.description.split(',')"
                      (click)="call(phone)">
                <span>{{phone}}</span>
              </button>
            </div>
          </mat-menu>
        </div>

        <autocomplete-item-field
          [dataType]="'PROJECT'"
          [canOpenItem]="!data.project?.id"
          [canOpenList]="true"
          [readonly]="!!data.project?.id || readonlyFlag"
          [canAddItem]="checkPermissions('PROJECT_ADD')"
          [canEditItem]="checkPermissions('PROJECT_EDIT')"
          [canDeleteItem]="checkPermissions('PROJECT_EDIT')"
          [required]="taskForm.get('type')?.value !== 'CALL' && taskForm.get('type')?.value !== 'LEAD' && taskForm.get('type')?.value !== 'SUPPORT' && taskForm.get('type')?.value !== 'TASK'"
          label="{{'modules.crm.leads.taskDialog.labels.project' | translate}}"
          formControlName="project">
        </autocomplete-item-field>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
          <mat-label>{{'modules.crm.leads.taskDialog.labels.text' | translate}}</mat-label>
          <textarea matInput formControlName="text" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
        </mat-form-field>
      </form>
    </div>
    <ng-container *ngIf="data.edit && data?.task?.id">
      <app-crm-feed
        [reference]="{referenceId: data?.task?.id, referenceType: 'TASK'}"
        [referenceData]="{id: data?.task?.id, name: data?.task?.date + ' ' + data?.task?.manager?.name}"
        [tasksAvailable]="false"
        [permissions]="permissions$ | async"
        [currentUser]="currentUser$ | async"
      >
      </app-crm-feed>
    </ng-container>
  </div>
</div>
<div class="buttons-row df jc-e ai-c gap20" *ngIf="!readonlyFlag" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
  <button class="default-button apply-button" [disabled]="taskForm.invalid" (click)="submitForm(false)" *ngIf="!data.prevTask">
    {{'common.save' | translate}}
  </button>
  <button class="default-button apply-button" [disabled]="taskForm.invalid" (click)="submitForm(true)">
    {{'common.saveAndClose' | translate}}
  </button>
</div>
